import { PauseCircle } from "lucide-react";

export default function PauseButton({ onClick }: any) {
  return (
    <div className="cursor-pointer" onClick={onClick}>
      <PauseCircle className="h-auto w-[60px] text-white" strokeWidth={1} />
    </div>
  );
}
